<template>
  <div 
    class="sm-tabs"
    :class="{
      'scroll-x': scroll,
      'btns': type == 'btns',
      'links': type == 'links'
    }"
  >
    <a 
      v-for="tab in tabs"
      :key="tab[param]"
      href="#"
      class="sm-tabs__item"
      :class="{
        'active': tab == currentTab,
        'sm-h4': type == 'btns',
        'sm-h5': type == 'links',
        'disabled': tab.disabled,
        'hidden': tab.hidden
      }"
      @click.prevent="switchTab(tab)"
    >
      {{tab.text}}
      <span 
        v-if="tab.items"
        class="sm-tabs__item-qty"
      >{{tab.items}}</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'tabs-elem',
  props: {
    tabs: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'btns' // values: btns, links
    },
    param: {
      type: String,
      default: 'tab'
    },
    scroll: {
      type: Boolean,
      default: false
    },
    preselect: {
      type: Boolean,
      default: true
    },
    defaultTabIndex: {
      type: Number,
      default: 0
    },
    updateQuery: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      currentTab: null
    };
  },
  created() {
    this.updateActiveTab(this.preselect);
  },
  methods: {
    updateActiveTab(preselect = true) {
      let query = this.$route.query;

      if (query[this.param]) {
        this.currentTab = this.tabs.find(tab => tab[this.param] == query[this.param]);
        
        if (!this.currentTab)
          this.switchTab(this.tabs[0]);
      } else {
        if (preselect)
          this.currentTab =  this.tabs[0];
        if(this.defaultTabIndex) this.currentTab = this.tabs[this.defaultTabIndex]
      }
    },
    switchTab(tab) {
      if (this.currentTab == tab || (!tab && this.currentTab == this.tabs[0]))
        return;

      this.currentTab = tab || this.tabs[0];
      
      this.$emit('switch', this.currentTab, this.param);

      if (this.updateQuery && this.param == 'tab') {
        let query = {};

        if (tab)
          query[this.param] = tab[this.param];

        this.$router.push({
          ...this.$route,
          ...{
            query: query
          }
        });
      }
    },
  },
  watch: {
    tabs(val) {
      this.updateActiveTab();
    },
    '$route.query'(val) {
      if (this.param == 'tab')
        this.updateActiveTab();
    }
  }
}
</script>
